<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useToast } from 'vue-toastification';
import { projectUtils } from '@/utils/project';
import { customerUtils } from '@/utils/customer';
import { allUsers, userById } from '@/utils/user';

export default {
 inject: ['setLoading'],  
  data() {
   return {
    id: '',
    ids: [], 
    task_id: '',
    errors: {}, 
    project_id: '',
    pipeline: '',
    users: [],
    user: '',
    manager: '',
    team_users: [],
    toast: useToast(), 
    customers: [],
    customer: '', 
    name: '',
    role: '',
    comment: '',
    description: '',
    priority: '', 
    status: '',
    budget: '',
    start_date: '',
    end_date: '',
    due_date: '',
    loading: false,
    estimated_hours: '',
    actual_hours: '',
    created_by: [],
    pipelines: [],
    task_comments: [],
    file: null,
   };
  },

  methods: {
   
   async myUsers(){
    const response = await allUsers();
    this.users = response.data.data;
   },

   async teamUsers(){
    try{
     const response = await axios.get(`/projects/${this.project_id}/team`);
     this.team_users = response.data.data; 
    }catch(error){
     this.$swalToast(error.message, 'error'); 
    }
   },

   async onSearch(search) {
    this.loading = true;
    this.customers = await customerUtils.onSearch(search);
    this.loading = false;
   },

   async getCustomerById(id) {
    this.customer = await customerUtils.getCustomerById(id);
   }, 

   async add(){
    await this.myUsers();
   },

   async project(row){
    await this.myUsers();
    this.id = row.id;
    await this.getCustomerById(row.customer_id);
    this.user = await userById(row.project_manager_id);
    this.name = row.name;
    this.description = row.description;
    this.priority = row.priority;
    this.status = row.status;
    this.budget = row.budget;
    this.start_date = this.$formatDate(row.start_date, 'YYYY-MM-DD');
    this.end_date = this.$formatDate(row.end_date, 'YYYY-MM-DD');
   },

   async saveProject(){
    this.errors = {};
    this.setLoading(true);
    try{
     const payload = {
      customer_id: this.customer?.id,
      project_manager_id: this.user?.id,
      name: this.name,
      description: this.description,
      priority: this.priority,
      status: this.status,
      budget: this.budget,
      start_date: this.start_date,
      end_date: this.end_date
     };
     let response = [];
     if(this.id){
      response = await axios.put(`/projects/${this.id}/update`, payload);
     }else{
      response = await axios.post(`/projects/create`, payload);
     }
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('project_modal');
     this.resetForm();
     this.close
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

   async deleteProject(){
    this.setLoading(true);
    try{
     const response = await axios.delete(`/projects/${this.id}/delete`);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('delete_modal');
     this.resetForm();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },

   async team(project_id){
    await this.myUsers();
    this.project_id = project_id;
   },

   async saveTeamMember(){
    this.errors = {};
    this.setLoading(true);
    try{
     const payload = {
      project_id: this.project_id,
      user_id: this.user.id,
      manager_id: this.manager.id,
      role: this.role,
      responsibilities: this.description
     }; 
     const response = await axios.post(`/projects/${this.project_id}/team/create`, payload);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('project_team_modal');
     this.resetForm();
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors;
     }else{ 
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

   removeTeamModal(id){
    this.id = id;
   },

   async removeTeam(){
    try{
     const response = await axios.delete(`/projects/team/${this.id}/delete`);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('remove_team_modal');
     this.resetForm();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }
   },

   async pipelineModal(project_id, pipeline_id){
    this.description = '';
    this.project_id = project_id;
    this.pipelines = await projectUtils.projectPipelines();
    this.pipeline = this.pipelines.find(p => p.id === pipeline_id);
   },

   async saveProjectPipeline(){
    this.errors = {};
    this.setLoading(true);
    try{
     const payload = {
      project_id: this.project_id,
      pipeline_id: this.pipeline?.id,
      notes: this.description,
     }; 
     const response = await axios.post(`/projects/${this.project_id}/pipeline/move`, payload);
     this.$swalToast(response.data.message); 
     this.$emit('updated');
     this.closeModal('project_pipeline_modal');
     this.resetForm();
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     } 
    }finally{
     this.setLoading(false); 
    }
   },

   async task(project_id, row = null){
    this.resetForm();
    this.project_id = project_id;
    await this.teamUsers();
    if(row){
     this.task_id = row.id; 
     this.name = row.name;
     this.description = row.description;
     this.status = row.status;
     this.priority = row.priority;
     this.actual_hours = row.actual_hours;
     this.estimated_hours = row.estimated_hours;
     this.start_date = this.$formatDate(row.start_date, 'YYYY-MM-DD');
     this.due_date = this.$formatDate(row.due_date, 'YYYY-MM-DD');
     this.completed_date = row.completed_date;
     this.user = this.team_users.find(u => u.user_id === row.assigned_to?.id);
     this.created_by = row.created_by;
     await this.taskComments();
    }
   },

   async saveProjectTask(){
    this.errors = {};
    this.setLoading(true);
    try{
     const payload = {
      project_id:      this.project_id,
      assigned_to:     this.user?.id,
      name:            this.name,
      description:     this.description,
      priority:        this.priority,
      status:          this.status,
      start_date:      this.start_date,
      due_date:        this.due_date,
      ...(!this.task_id && {estimated_hours: this.estimated_hours}),
      ...(this.task_id && {actual_hours: this.actual_hours})
     }; 
     let response = [];
     if(this.task_id){
      response = await axios.put(`/projects/tasks/${this.task_id}/update`, payload);
     }else{
      response = await axios.post(`/projects/${this.project_id}/tasks/create`, payload);
     }
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('project_task_modal');
     this.resetForm();
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors; 
     }else{
      this.$swalToast(error.message, 'error');
     } 
    }finally{
     this.setLoading(false); 
    }
   },

   async deleteProjectTask(){
    this.setLoading(true);
    try{
     const response = await axios.delete(`/projects/tasks/${this.task_id}/delete`);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('project_task_delete_modal');
     this.resetForm(); 
    }catch(error){
     this.$swalToast(error.message, 'error'); 
    }finally{
     this.setLoading(false); 
    }
   },

   async taskComments(){
    try{
     const response = await axios.get(`/projects/tasks/${this.task_id}/comments`);
     this.task_comments = response.data.data; 
    }catch(error){
     this.$swalToast(error.message, 'error'); 
    }  
   },

   async saveTaskComment(){
    this.errors = {};
    this.setLoading(true);
    try{
     let payload = {
      comment: this.comment
     }; 
     let response = [];
     if(this.id){
      response = await axios.put(`/projects/task-comments/${this.id}/update`, payload);
     }else{
      response = await axios.post(`/projects/tasks/${this.task_id}/comments/create`, payload); 
     }
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('project_task_view_modal');
     this.resetForm();
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors; 
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

   newComment(){
    this.id = '';
    this.comment = '';
   },

   editTaskComment(id, comment){
    this.id = id;
    this.comment = comment;

    this.$nextTick(() => {
     this.$refs.commentForm.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center'
     });
    });
   },

   async markAsCompleted(){
    this.setLoading(true);
    try{
     const response = await axios.patch(`/projects/tasks/${this.task_id}/mark-completed`);
     this.$swalToast(response.data.message); 
     this.$emit('updated');
     this.closeModal('project_task_mark_completed_modal');
     this.resetForm();
    }catch(error){
     this.$swalToast(error.message, 'error'); 
    }finally{
     this.setLoading(false); 
    }
   },

   async saveProjectTaskStatus(){
    this.setLoading(true);
    try{
     await projectUtils.saveProjectTaskStatus(this.task_id, this.status);
     this.$swalToast('Task status updated successfully');
     this.$emit('updated');
     this.closeModal('project_task_status_modal');
     this.resetForm();
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    }
   },

// ##########################################################
//     ************** PROJECT DOCUMENT ****************
// ##########################################################

   async document(project_id, row = null){
    this.resetForm();
    this.project_id = project_id;
    if(row){
     this.id = row.id; 
     this.name = row.name;
     this.description = row.description;
    }
   },

   handleFileUpload(event){
    this.file = event.target.files[0];
   },

   async saveProjectDocument(){
    this.errors = {};
    this.setLoading(true);
    try{
     const formData = new FormData();
     formData.append('file', this.file);
     formData.append('name', this.name);
     formData.append('description', this.description);
     
     let response = [];
     if(this.id){
      response = await axios.put(`/projects/documents/${this.id}/update`, formData);
     }else{
      response = await axios.post(`/projects/${this.project_id}/documents/create`, formData, {
       headers: { 'Content-Type': 'multipart/form-data',},
      });
     }
      
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('project_document_modal');
     this.resetForm();
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     } 
    }finally{
     this.setLoading(false); 
    }
   },

   async deleteProjectDocument(){
    this.setLoading(true);
    try{
     const response = await axios.delete(`/projects/documents/${this.id}/delete`);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.closeModal('project_document_delete_modal');
     this.resetForm();  
    }catch(error){
     this.$swalToast(error.message, 'error'); 
    }finally{
     this.setLoading(false); 
    }
   },

   closeModal(modalId) {
    const modalEl = document.getElementById(modalId);
    const modal = Modal.getInstance(modalEl);
    if (modal) modal.hide();
   },

   resetForm() {
    this.id = null;
    this.task_id = '';
    this.errors = {}; 
    this.customer = '';
    this.user = '';
    this.manager = '';
    this.name = '';
    this.comment = '';
    this.description = '';
    this.priority = '';
    this.status = '';
    this.budget = '';
    this.start_date = '';
    this.end_date = '';
    this.due_date = '';
   }

  },

};
</script>

<template>

<!-- Add -->
<div class="modal fade" id="project_modal">
<div class="modal-dialog modal-dialog-centered modal-mg w-100">
<div class="modal-content">
  <div class="modal-header">
   <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Project</h4>
   <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
   </button>
  </div>
  <form @submit.prevent="saveProject">
  <div class="modal-body pb-0">
  <div class="row">

    <div class="col-md-6">
    <div class="mb-3">  
    <label class="form-label">Customer <span class="text-danger">*</span></label>
    <vue-select :options="customers" label="name" v-model="customer" placeholder="Select Customer" :loading="loading" :filterable="false" @search="onSearch"/>
    <div v-if="errors.customer_id" class="text-danger small mt-1">{{ errors.customer_id[0] }}</div>
    </div>
    </div>

    <div class="col-md-6">
    <div class="mb-3">  
    <label class="form-label">Manager <span class="text-danger">*</span></label>
    <vue-select :options="users" label="name" v-model="user" placeholder="Select Manager"/>
    <div v-if="errors.project_manager_id" class="text-danger small mt-1">{{ errors.project_manager_id[0] }}</div>
    </div>
   </div> 

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Name</label>
      <input type="text" class="form-control" v-model="name" />
      <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">Priority</label>
      <select class="form-select" v-model="priority">
       <option value="">Select</option> 
       <option value="Low">Low</option>
       <option value="Medium">Medium</option>
       <option value="High">High</option>
       <option value="Urgent">Urgent</option>
      </select>
      <div v-if="errors.priority" class="text-danger small mt-1">{{ errors.priority[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">Status</label>
      <select class="form-select" v-model="status">
       <option value="">Select</option>
       <option value="Planning">Planning</option>
       <option value="In Progress">In Progress</option>
       <option value="On Hold">On Hold</option>
       <option value="Completed">Completed</option>
       <option value="Cancelled">Cancelled</option>
      </select>
      <div v-if="errors.status" class="text-danger small mt-1">{{ errors.status[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">Budget</label>
      <input type="number" class="form-control" v-model="budget" />
      <div v-if="errors.budget" class="text-danger small mt-1">{{ errors.budget[0] }}</div>
    </div>
    </div>

    <div class="col-md-6">
    <div class="mb-3">
      <label class="form-label">Start Date</label>
      <input type="date" class="form-control" v-model="start_date" />
      <div v-if="errors.start_date" class="text-danger small mt-1">{{ errors.start_date[0] }}</div>
    </div>
    </div>

    <div class="col-md-6">
    <div class="mb-3">
      <label class="form-label">End Date</label>
      <input type="date" class="form-control" v-model="end_date" />
      <div v-if="errors.end_date" class="text-danger small mt-1">{{ errors.end_date[0] }}</div>
    </div>
    </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Description</label>
      <textarea class="form-control" v-model="description"></textarea>
      <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
    </div>
    </div>
        
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">{{ id ? 'Update' : 'Add' }}</button>
    </div>
</form>
  </div>
</div>
</div>
<!-- /Add -->

<!-- Delete Modal -->
<div class="modal fade" id="delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
  <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
    <i class="ti ti-trash-x fs-36"></i>
  </span>
  <h4 class="mb-1">Confirm Delete</h4>
  <p class="mb-3">
    You want to delete the item, this cant be undone once you delete.
  </p>
  <div class="d-flex justify-content-center">
    <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-danger" @click="deleteProject">Yes, Delete</a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Delete Modal -->

<!-- Team Member -->
<div class="modal fade" id="project_team_modal">
<div class="modal-dialog modal-dialog-centered modal-mg w-100">
<div class="modal-content">
  <div class="modal-header">
   <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Project Team Member</h4>
   <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
   </button>
  </div>
  <form @submit.prevent="saveTeamMember">
  <div class="modal-body pb-0">
  <div class="row">

    <div class="col-md-6">
    <div class="mb-3">  
    <label class="form-label">User <span class="text-danger">*</span></label>
    <vue-select :options="users" label="name" v-model="user" placeholder="Select User"/>
    <div v-if="errors.user_id" class="text-danger small mt-1">{{ errors.user_id[0] }}</div>
    </div>
   </div>
   
   <div class="col-md-6">
    <div class="mb-3">  
    <label class="form-label">Manager <span class="text-danger">*</span></label>
    <vue-select :options="users" label="name" v-model="manager" placeholder="Select User"/>
    <div v-if="errors.manager_id" class="text-danger small mt-1">{{ errors.manager_id[0] }}</div>
    </div>
   </div>

    <div class="col-md-5">
    <div class="mb-3">
      <label class="form-label">Roles</label>
      <select class="form-select" v-model="role">
       <option value="">Select</option> 
       <option value="Team Lead">Team Lead</option>
       <option value="Developer">Developer</option>
       <option value="Designer">Designer</option>
       <option value="Tester">Tester</option>
       <option value="Analyst">Analyst</option>
       <option value="Other">Other</option>
      </select>  
      <div v-if="errors.role" class="text-danger small mt-1">{{ errors.role[0] }}</div>
    </div>
    </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Responsibilities</label>
      <textarea class="form-control" v-model="description"></textarea>
      <div v-if="errors.responsibilities" class="text-danger small mt-1">{{ errors.responsibilities[0] }}</div>
    </div>
    </div>
        
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">{{ id ? 'Update' : 'Add' }}</button>
    </div>
</form>
  </div>
</div>
</div>
<!-- /Team Member -->

<!-- Remove Team Modal -->
<div class="modal fade" id="remove_team_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
  <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
    <i class="ti ti-trash-x fs-36"></i>
  </span>
  <h4 class="mb-1">Confirm Remove</h4>
  <p class="mb-3">
    You want to remove the item, this cant be undone once you remove.
  </p>
  <div class="d-flex justify-content-center">
    <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-danger" @click="removeTeam">Yes, Remove</a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Remove Team Modal -->

<!-- Pipeline -->
<div class="modal fade" id="project_pipeline_modal">
<div class="modal-dialog modal-dialog-centered modal-sm modal-mg w-100">
<div class="modal-content">
  <div class="modal-header">
   <h4 class="modal-title">Update Project Pipeline</h4>
   <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
   </button>
  </div>
  <form @submit.prevent="saveProjectPipeline">
  <div class="modal-body pb-0">
  <div class="row">

    <div class="col-md-12">
    <div class="mb-3">  
    <label class="form-label">Pipeline <span class="text-danger">*</span></label>
    <vue-select :options="pipelines" label="name" v-model="pipeline" placeholder="Select Pipeline"/>
    <div v-if="errors.pipeline_id" class="text-danger small mt-1">{{ errors.pipeline_id[0] }}</div>
    </div>
   </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Notes</label>
      <textarea class="form-control" v-model="description"></textarea>
      <div v-if="errors.note" class="text-danger small mt-1">{{ errors.note[0] }}</div>
    </div>
    </div>
        
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">Save</button>
    </div>
</form>
  </div>
</div>
</div>
<!-- /Pipeline -->

<!-- Task -->
<div class="modal fade" id="project_task_modal">
<div class="modal-dialog modal-dialog-centered modal-mg w-100">
<div class="modal-content">
  <div class="modal-header">
   <h4 class="modal-title">{{ task_id ? "Edit" : "Add" }} Task</h4>
   <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
   </button>
  </div>
  <form @submit.prevent="saveProjectTask">
  <div class="modal-body pb-0">
  <div class="row">

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Name</label>
      <input class="form-control" v-model="name" />
      <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">Priority</label>
      <select class="form-select" v-model="priority">
       <option value="">Select</option> 
       <option value="Low">Low</option>
       <option value="Medium">Medium</option>
       <option value="High">High</option>
       <option value="Urgent">Urgent</option>
      </select>
      <div v-if="errors.priority" class="text-danger small mt-1">{{ errors.priority[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">Status</label>
      <select class="form-select" v-model="status">
       <option value="">Select</option> 
       <option value="To Do">To Do</option>
       <option value="In Progress">In Progress</option>
       <option value="Review">Review</option>
       <option value="Completed">Completed</option>
       <option value="Cancelled">Cancelled</option>
      </select>
      <div v-if="errors.status" class="text-danger small mt-1">{{ errors.status[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3" v-if="!task_id">
      <label class="form-label">Estimated Hours</label>
      <input type="number" class="form-control" v-model="estimated_hours" />
      <div v-if="errors.estimated_hours" class="text-danger small mt-1">{{ errors.estimated_hours[0] }}</div>
    </div>
    <div class="mb-3" v-else>
      <label class="form-label">Actual Hours</label>
      <input type="number" class="form-control" v-model="actual_hours" />
      <div v-if="errors.actual_hours" class="text-danger small mt-1">{{ errors.actual_hours[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">Start Date</label>
      <input type="date" class="form-control" v-model="start_date" />
      <div v-if="errors.start_date" class="text-danger small mt-1">{{ errors.start_date[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">
      <label class="form-label">Due Date</label>
      <input type="date" class="form-control" v-model="due_date" />
      <div v-if="errors.due_date" class="text-danger small mt-1">{{ errors.due_date[0] }}</div>
    </div>
    </div>

    <div class="col-md-4">
    <div class="mb-3">  
      <label class="form-label">Assigned To <span class="text-danger">*</span></label>
      <vue-select :options="team_users?.map(u => u.user)" label="name" v-model="user" placeholder="Select User"/>
      <div v-if="errors.assigned_to" class="text-danger small mt-1">{{ errors.assigned_to[0] }}</div>
    </div>
    </div>

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Description</label>
      <textarea class="form-control" v-model="description"></textarea>
      <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
    </div>
    </div>
    
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">Save</button>
    </div>
  </form>
  </div>
</div>
</div>
<!-- /Task -->

<!-- Delete Task Modal -->
<div class="modal fade" id="project_task_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
  <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
    <i class="ti ti-trash-x fs-36"></i>
  </span>
  <h4 class="mb-1">Confirm Delete</h4>
  <p class="mb-3">
    You want to delete the item, this cant be undone once you delete.
  </p>
  <div class="d-flex justify-content-center">
    <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-danger" @click="deleteProjectTask">Yes, Remove</a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Delete Task Modal -->

<!-- Project Task View -->
<div class="modal fade" id="project_task_view_modal">
<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
<div class="modal-content">
<div class="modal-header bg-dark">
<h6 class="modal-title text-white">{{ name }}</h6>
<button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body">
<div class="border rounded mb-3 p-2">
<div class="row row-gap-3">
 <div class="col-md-4 col-4">
 <div class="text-center">
   <span class="d-block mb-1 fw-bold">Priority</span>
   <p class="text-dark fw-normal">{{ priority }}</p>
 </div>
 </div>
 <div class="col-md-4 col-4">
 <div class="text-center">
    <span class="d-block mb-1 fw-bold">Status</span>
    <p class="text-dark fw-normal">{{ status }}</p>
 </div>
 </div>
 <div class="col-md-4 col-4">
 <div class="text-center">
 <span class="d-block mb-1 fw-bold">Estimated Time</span>
  <span class="badge bg-secondary d-inline-flex align-items-center">{{ estimated_hours }} hours</span>
 </div>
 </div>
</div>
</div>

 <div class="border rounded mb-3 p-2">
 <div class="row row-gap-3">
 <div class="col-md-6 col-6">
 <div class="text-center">
   <span class="d-block mb-1 fw-bold">Created By</span>
   <p class="text-dark fw-normal">
    <img :src="$profileImage(created_by?.image, clientAdmin)" width="22" /> {{ created_by?.name }}
   </p>
 </div>
 </div>

 <div class="col-md-6 col-6">
 <div class="text-center" v-if="actual_hours">
 <span class="d-block mb-1 fw-bold">Acutal Time</span>
  <span class="badge bg-secondary d-inline-flex align-items-center">{{ actual_hours }} hours</span>
 </div>
  </div>
 </div>
 </div>

 <div class="mb-3" v-if="description">
 <h5 class="mb-2">Notes</h5>
 <p v-html="description" style="max-height: 150px; overflow-y: auto;"></p>
 </div>

 <div class="schedule-timeline">

  <div class="d-flex align-items-center">
  <div class="d-flex align-items-center active-time"><span class="timeline-date text-info">{{ $formatDate(start_date, 'DD-MM-YYYY') }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
  <div class="flex-fill ps-3 pb-4 timeline-hrline">
   <div class="mt-4">
    <p class="fw-medium text-gray-9 mb-1">Start Date</p>
   </div>
  </div>
  </div>

  <div class="d-flex align-items-center">
  <div class="d-flex align-items-center active-time"><span class="timeline-date text-danger">{{ (due_date !== null) ? $formatDate(due_date, 'DD-MM-YYYY') : 'N/A' }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
  <div class="flex-fill ps-3 pb-4 timeline-hrline">
   <div class="mt-4">
    <p class="fw-medium text-gray-9 mb-1">Due Date</p>
   </div>
  </div>
  </div>

  <div class="d-flex align-items-center">
  <div class="d-flex align-items-center active-time"><span class="timeline-date text-success">{{ (completed_date !== null) ? $formatDate(completed_date, 'DD-MM-YYYY') : 'N/A' }}</span><span class="timeline-border d-flex align-items-center justify-content-center bg-white"><i class="ti ti-point-filled text-gray-2 fs-18"></i></span></div>
  <div class="flex-fill ps-3 pb-4 timeline-hrline">
   <div class="mt-4">
    <p class="fw-medium text-gray-9 mb-1">Completed Date</p>
   </div>
  </div>
  </div>  
   
  <div class="d-flex align-items-center">
    <div class="flex-fill ps-3 pb-0 timeline-hrline"></div>
  </div>
</div>

 <!-- Task Comments -->
<hr>

 <div class="border rounded mb-3 p-2" ref="commentForm" v-if="status !== 'Completed'">
 <form @submit.prevent="saveTaskComment"> 
 <div class="row row-gap-3">
 <div class="col-md-10 col-10">
  <textarea class="form-control" v-model="comment" placeholder="Enter Comments"></textarea>
  <div class="text-danger small" v-if="errors.comment">{{ errors.comment[0] }}</div>
 </div>
 <div class="col-md-2 col-2">
  <button type="submit" class="btn btn-sm btn-info" @click="newComment" v-if="id">New</button>
  <button type="submit" class="btn btn-sm btn-primary mt-3">Save</button>
 </div>
 </div>
 </form>
 </div>

 <div id="accordion">

 <div class="card">
  <div class="card-header p-0">
    <a class="btn" data-bs-toggle="collapse" href="#collapseOne">Comments History</a>
  </div>
  <div id="collapseOne" class="collapse show" data-bs-parent="#accordion">
   <div class="card-body">
    <template v-if="task_comments?.length">  
    <div class="border rounded p-3 mb-3" v-for="row in task_comments">
    <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="d-flex align-items-center">
      <span class="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
        <img :src="$profileImage(row.user?.image, clientAdmin)" alt="Img" width="22" />
      </span>
      <div>
        <h6 class="fw-medium mb-1">{{ row.user?.name }}</h6>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <span> <i class="ti ti-clock-hour-9"></i> {{ $formatDate(row.created_at, 'DD MMM YYYY, hh:mm a') }}</span>
      <a href="javascript:void(0);" class="btn btn-icon btn-sm" @click="editTaskComment(row?.id, row?.comment);"><i class="ti ti-edit"></i></a>
      <!-- <a href="javascript:void(0);" class="btn btn-icon btn-sm" data-bs-toggle="modal"
      data-bs-target="#note_delete_modal"><i class="ti ti-trash"></i></a> -->
    </div>
   </div>
   <div>
    <!-- <h6 class="fw-medium mb-2">Notes added by Antony</h6> -->
    <p class="mb-3" v-html="row.comment"></p>
   </div>
  </div>
  </template>  
   </div>
  </div>
 </div>

 </div>

</div>
</div>
</div>
</div>
<!-- /Project Task View -->

<!-- Task Marked As Completed Modal -->
<div class="modal fade" id="project_task_mark_completed_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
  <span class="avatar avatar-xl bg-transparent-success text-success mb-3">
    <i class="ti ti-progress-check fs-36"></i>
  </span>
  <h4 class="mb-1">Confirm Completed</h4>
  <p class="mb-3">
    You want to mark the task as completed, this cant be undone once you done.
  </p>
  <div class="d-flex justify-content-center">
    <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-success" @click="markAsCompleted">Yes, do it</a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Task Marked As Completed Modal -->

<!-- Task Status -->
<div class="modal fade" id="project_task_status_modal">
<div class="modal-dialog modal-dialog-centered modal-sm w-100">
<div class="modal-content">
  <div class="modal-header">
   <h4 class="modal-title">Update Task Status</h4>
   <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
   </button>
  </div>
  <form @submit.prevent="saveProjectTaskStatus">
  <div class="modal-body pb-0">
  <div class="row">

    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Status</label>
      <select class="form-select" v-model="status">
       <option value="">Select</option> 
       <option value="To Do">To Do</option>
       <option value="In Progress">In Progress</option>
       <option value="Review">Review</option>
       <option value="Completed">Completed</option>
       <option value="Cancelled">Cancelled</option>
      </select>
      <div v-if="errors.status" class="text-danger small mt-1">{{ errors.status[0] }}</div>
    </div>
    </div>
    
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">Save</button>
    </div>
  </form>
  </div>
</div>
</div>
<!-- /Task Status -->

<!-- Document -->
<div class="modal fade" id="project_document_modal">
<div class="modal-dialog modal-dialog-centered modal-mg w-100">
<div class="modal-content">
  <div class="modal-header">
   <h4 class="modal-title">{{ id ? "Edit" : "Add" }} Document</h4>
   <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
   </button>
  </div>
  <form @submit.prevent="saveProjectDocument">
  <div class="modal-body pb-0">

  <div class="row">

  <div class="col-md-6" v-if="!id">
  <div class="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
  <div class="profile-upload">
  <div class="mb-2">
  <h6 class="mb-1">Upload Document</h6>
  <!-- <p class="fs-12">Recommended: 250px x 250px</p> -->
  </div>
  <div class="profile-uploader d-flex align-items-center">
   <input type="file" class="form-control image-sign" @change="handleFileUpload"/> 
  </div>
  <div v-if="errors.file" class="text-danger small mt-1">{{ errors.file[0] }}</div>
  </div>
  </div>
  </div>  

   <div :class="(!id ? 'col-md-6' : 'col-md-12')">
   <div class="mb-3">
   <label class="form-label">Name <span class="text-danger"> *</span></label>
   <input type="text" class="form-control" v-model="name" />
   <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
   </div>
   </div>

  </div>  

  <div class="row">
    <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label">Description</label>
      <textarea class="form-control" v-model="description"></textarea>
      <div v-if="errors.description" class="text-danger small mt-1">{{ errors.description[0] }}</div>
    </div>
    </div>
    
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">Save</button>
    </div>
  </form>
  </div>
</div>
</div>
<!-- /Document -->

<!-- Delete Modal -->
<div class="modal fade" id="project_document_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
  <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
    <i class="ti ti-trash-x fs-36"></i>
  </span>
  <h4 class="mb-1">Confirm Delete</h4>
  <p class="mb-3">
    You want to delete the item, this cant be undone once you delete.
  </p>
  <div class="d-flex justify-content-center">
    <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-danger" @click="deleteProjectDocument">Yes, Delete</a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Delete Modal -->

<!-- Project Document View -->
<div class="modal fade" id="project_document_view_modal">
<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
<div class="modal-content">
<div class="modal-header bg-dark">
<h6 class="modal-title text-white">{{ name }}</h6>
<button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body">

 <div class="mb-3" v-if="description">
 <h5 class="mb-2">Notes</h5>
 <p v-html="description" style="max-height: 150px; overflow-y: auto;"></p>
 </div>

</div>
</div>
</div>
</div>
<!-- /Project Document View -->

</template>
